var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.8273 19H3.5C2.1 19 1 17.9 1 16.5V3.5C1 2.1 2.1 1 3.5 1H16.5C17.9 1 19 2.1 19 3.5V16.5C19 17.9 17.9 19 16.5 19H13.2727L13.2636 12.0455H15.7455L16.1455 9.59091H13.2727L13.2864 8.00455C13.2864 7.30455 13.4545 6.80455 14.5045 6.80455L16.1364 6.72727V4.27273C16.1364 4.27273 14.8045 4.30455 13.9045 4.30455C12.0045 4.30455 10.8273 5.35455 10.8273 7.50455L10.8136 9.59091H8.35L8.35455 12.0455H10.8182L10.8273 19Z","fill":"#282828"}));
}

FacebookInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#282828"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
